import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_sskrdryawp: FaireBrandEntity = {
  token: "b_sskrdryawp",
  type: "brand",
  name: "Someday Studio",
  avatarUrl:
    "https://cdn.faire.com/fastly/117c91f5989d2bfb467dd9066a3d4e0f6b68bcfd57fe0b2bb147f507c780d0be.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d8da963a9ebbcd957be8f483c77f7ec466557fe74219ddb1802592e22314d6a4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/117c91f5989d2bfb467dd9066a3d4e0f6b68bcfd57fe0b2bb147f507c780d0be.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d8da963a9ebbcd957be8f483c77f7ec466557fe74219ddb1802592e22314d6a4.png",
  location: "Clinton, MA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 45,
  isInsider: true,
  description:
    "All products are packaged in a 100% home compostable cello sleeve. Learn more here: https://www.someday.studio/compostable-cello\n___\n\nEvery “Someday…” starts with a dream. Ours began a few years ago when we were both hired to brand and establish a new boutique stationery line as part of our nine-to-five.\n\nIt was there that two sister-in-laws discovered a passion for creating products that not only made life more beautiful, they also made it a helluva lot easier. This discovery sparked a series of conversations that we’ve later coined our ‘someday sessions.’ They went a little something like this:\n\n“Someday we should…”\n“Ohh what if someday our company made…”\n“Do you think someday we could…”\n(You get the gist)\n\nRoughly 10,000 somedays later, we decided enough was enough. We were done putting off our dream and decided we wanted to help others do the same. So here we are — we hope our products help you turn your somedays into today.  ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:18.542Z",
    importedBy: "entity-db-cli",
  },
};
